import { useDispatch } from "react-redux";

import config from "config";

import { datadogRum } from "@datadog/browser-rum";
import TagManager from "analytics/middleware/TagManager";

import SetAdvisor from "data/advisor/actions";
import history from "data/history";
import { GetAdvisor } from "data/libs/advisor";
import { ConnectWebsocket } from "data/websockets/actions";

export function useAppConfig() {
  const dispatch = useDispatch();

  return {
    init: async () => {
      try {
        const resp = await GetAdvisor();
        if (config.datadog) {
          datadogRum.setUser({
            user_id: resp.id,
            email: resp.email,
            name: `${resp.firstName} ${resp.lastName}`,
            hub: resp.hubs?.[0]?.hubId,
          });
        }
        TagManager.dataLayer({
          dataLayer: {
            user: {
              id: resp.id,
              email: resp.email,
              name: `${resp.firstName} ${resp.lastName}`,
            },
          },
        });
        dispatch(SetAdvisor(resp));
        dispatch(ConnectWebsocket());
      } catch (error) {
        console.error(error);
        history.push(`/error`);
      }
    },
    destroy: () => {
      history.push("/");
    },
  };
}

export default useAppConfig;
